const DEFAULT_FIXED = 2;

export const convertNumberToString = (
  amount?: string | number,
  fixed = DEFAULT_FIXED
): string => {
  return Number(amount)
    .toFixed(fixed)
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
